(function() {
    'use strict';

    angular.module('allegro').controller('AllegroCodReceiverUpdateController', AllegroCodReceiverUpdateController);

    AllegroCodReceiverUpdateController.$inject = [
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroCodReceiversDataSrvc',
        'allegroCodReceiverMessagesConst'
    ];

    function AllegroCodReceiverUpdateController(
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroCodReceiversDataSrvc,
        allegroCodReceiverMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            account: [],
            name: [],
            iban: []
        };

        self.account = {};
        self.receiverData = {
            account: null,
            name: '',
            iban: '',
        };

        self.getAccount = getAccount;
        self.getReceiverData = getReceiverData;
        self.updateReceiver = updateReceiver;
        self.cleanErrors = cleanErrors;

        active();

        function active(){
            self.loading = true;

            self.getReceiverData($stateParams.pk).then(function(response) {
                if (response.account) {
                    return self.getAccount(response.account);
                }
            })
            .then(function(data) {
                self.loading = false;
            });
        }

        function getAccount(accountPk) {
            self.loading = true;

            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function getReceiverData(receiverPk){
            return allegroCodReceiversDataSrvc.get({pk: receiverPk})
                .$promise
                .then(function (response) {
                    self.receiverData = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function updateReceiver() {
            allegroCodReceiversDataSrvc.update({pk: self.receiverData.pk}, self.receiverData)
                .$promise
                .then(function(response) {
                    notificationSrvc.notification("success", allegroCodReceiverMessagesConst.update);
                    $state.go('layout.allegro-accounts.detail.settings', {pk: self.account.pk});
                })
                .catch(function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
